export const TestIds = {
  actionLogModal: 'action-log-modal',
  adminBody: 'admin-body',
  calendarModalCloseButton: 'calendar-modal-close-button',
  contextSidebar: 'context-sidebar',
  crossSellSearchModal: 'cross-sell-search-modal',
  editBoxes: 'edit-boxes',
  errorText: 'error-text',
  floorPlanLink: 'floor-plan-link',
  inboxContent: 'inbox-content',
  inboxSidebar: 'inbox-sidebar',
  leasingPageScrollPane: 'leasing-page-scroll-pane',
  leasingTaskLink: 'leasing-task-link',
  modalCloseButton: 'modal-close-button',
  retryActionButton: 'retry-action-button',
  savedActionRow: 'saved-action-row',
  shortcutsModal: 'shortcuts-modal',
  tableMultiselectCheckbox: 'table-multiselect-checkbox',
  threadDetailBody: 'thread-detail-body',
  unauthorizedContainer: 'unauthorized-container',
  noteMessageLink: 'note-message-link',
  noteBody: 'note-body',
  dashboardTableCell: 'ops-dash-tbl-cell',
}
